
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"tourInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProspectTourInfoDTO"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerNote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertyAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prospectPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tourAgentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tourAgentName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tourPropertyName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tourType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeZone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timeZoneText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"propertyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prospectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prospectName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prospectEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelNote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tourAgentTourDuration"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":340}};
    doc.loc.source = {"body":"fragment tourInfo on ProspectTourInfoDTO {\n  customerNote\n  startTime\n  id\n  propertyAddress\n  propertyName\n  prospectPhone\n  tourAgentId\n  tourAgentName\n  tourPropertyName\n  tourType\n  timeZone\n  timeZoneText\n  propertyId\n  status\n  prospectId\n  eventId\n  cancelReason\n  prospectName\n  prospectEmail\n  cancelNote\n  tourAgentTourDuration\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["tourInfo"] = oneQuery(doc, "tourInfo");
        
